export const CHECK_TITLES = {
  recognize_passport: 'Распознавание паспорта',
  recognize_driver_license: 'Распознавание водительского удостоверения',
  check_driver_license: 'Проверка водительского удостоверения в ГИБДД',
  check_passport: 'Комплексная проверка паспорта',
  check_selfie: 'Сравнение лица на селфи с паспортом',
  check_phone_person: 'Соответствие ФИО и телефона',
  check_adult: 'Проверка совершеннолетия',
  check_fssp_debt: 'Задолженности ФССП',
  check_bankrupt: 'Перечень банкротств',
  check_terrorist: 'Перечень террористов и экстремистов',
  check_controlled_person: 'Реестр контролируемых лиц',
  check_mvd_wanted: 'Розыск МВД',
  check_fssp_wanted: 'Розыск ФССП',
  check_fsin_wanted: 'Розыск ФСИН',
  check_phone_lifetime: 'Срок жизни телефонного номера',
  check_phone_activity: 'Активность телефонного номера',
  check_alimony_debt: 'Должники по алиментам',
  check_credit_score: 'Финансовый скоринг БКИ',
  check_court_cases: 'Дела в судах общей юрисдикции',
  check_kbm: 'Аварийность по ОСАГО (КБМ)',
  check_driver_requirements: 'Возраст и стаж водителя',
  check_document_consistency: 'Согласованность документов',
  check_internal_history: 'История клиента в прокате',
  check_duplicate_identity: 'Документы в других учётных записях',
};

export const PROVIDER_LABELS = {
  idx: 'IDX',
  local: 'локальная',
};

export const TRIGGER_LABELS = {
  manual: 'запущена оператором',
  auto: 'автозапуск после подачи документов',
};

/**
 * Уровни риска клиента. Оценка рекомендательная: даже критический уровень
 * означает «оператор обязан отказать», а не автоматический отказ.
 */
export const RISK_LEVEL_META = {
  critical: {label: 'Критический', advice: 'рекомендуется отказ', tone: 'danger'},
  high: {label: 'Высокий', advice: 'выдача только с компенсирующими мерами', tone: 'attention'},
  medium: {label: 'Средний', advice: 'стандартные условия, внимание при выдаче и приёме', tone: 'information'},
  low: {label: 'Низкий', advice: 'ограничений нет', tone: 'clear'},
  unknown: {label: 'Не определён', advice: 'проверки ещё не дали результата', tone: 'neutral'},
};

export const riskLevelMeta = level => RISK_LEVEL_META[level] || RISK_LEVEL_META.unknown;

export const riskLabel = risk => {
  const meta = riskLevelMeta(risk && risk.level);
  if (!risk || risk.score === null || risk.score === undefined) { return meta.label; }
  return `${meta.label} · ${risk.score} %`;
};

export const STATUS_META = {
  pending: {label: 'Ожидается ответ IDX', tone: 'pending'},
  succeeded: {label: 'IDX ответил', tone: 'complete'},
  skipped: {label: 'Не запускалась', tone: 'neutral'},
  failed: {label: 'Техническая ошибка', tone: 'danger'},
};

export const OUTCOME_META = {
  clear: {label: 'Совпадений не выявлено', tone: 'clear'},
  attention: {label: 'Требует внимания оператора', tone: 'attention'},
  information: {label: 'Информационный результат', tone: 'information'},
  inconclusive: {label: 'Нет итогового результата', tone: 'neutral'},
};

export const FIELD_LABELS = {
  resultCode: 'Код результата IDX',
  resultMessage: 'Сообщение IDX',
  operationToken: 'Токен асинхронной операции',
  totalCount: 'Количество совпадений',
  records: 'Совпавшие записи',
  data: 'Найденные записи',
  list: 'Список совпадений',
  debtor: 'ФИО должника',
  category: 'Статус должника',
  fio: 'ФИО',
  fullName: 'ФИО',
  lastName: 'Фамилия',
  firstName: 'Имя',
  midName: 'Отчество',
  birthdate: 'Дата рождения',
  birthDate: 'Дата рождения',
  birthplace: 'Место рождения',
  region: 'Регион',
  address: 'Адрес',
  inn: 'ИНН',
  ogrn: 'ОГРНИП',
  snils: 'СНИЛС',
  messages: 'Сообщения',
  publicationType: 'Вид публикации',
  number: 'Номер',
  date: 'Дата',
  isAnnulled: 'Аннулировано',
  type: 'Тип',
  actType: 'Тип акта',
  sex: 'Пол',
  reason: 'Причина',
  info: 'Сведения',
  url: 'Ссылка на источник',
  createdAt: 'Дата записи',
  found: 'Найдено совпадение',
  score: 'Оценка IDX',
  description: 'Описание',
  operationResult: 'Результат операции',
  operationMessage: 'Пояснение',
  faces: 'Сравнение лиц',
  equal: 'Лица совпадают',
  similarity: 'Сходство',
  items: 'Распознанные документы',
  fields: 'Распознанные поля',
  confidence: 'Уверенность распознавания',
  text: 'Значение',
  docType: 'Тип документа',
  responses: 'Ответы по файлам',
  kind: 'Тип файла',
  payload: 'Ответ IDX',
  files: 'Отправленные файлы',
  missing_requirements: 'Недостающие данные',
};

export const checkTitle = type => CHECK_TITLES[type] || type;
export const providerLabel = provider => PROVIDER_LABELS[provider] || provider || 'IDX';
export const triggerLabel = trigger => TRIGGER_LABELS[trigger] || '';
export const statusMeta = status => STATUS_META[status]
  || {label: status || 'Статус неизвестен', tone: 'neutral'};

export const outcomeMeta = check => {
  if (check && check.outcome && check.outcome !== 'inconclusive'
      && OUTCOME_META[check.outcome]) {
    return OUTCOME_META[check.outcome];
  }
  const summary = String((check && check.summary) || '');
  if (/найден|совпадени|младше 18|не подтвержден/i.test(summary)
      && !/не найден|не выявлен/i.test(summary)) {
    return OUTCOME_META.attention;
  }
  if (/не найден|не выявлен|подтвержден/i.test(summary)) { return OUTCOME_META.clear; }
  return OUTCOME_META.inconclusive;
};

export const fieldLabel = key => FIELD_LABELS[key] || key;
